<template>
  <div>
    <mynav></mynav>
    <div class="videoBg">
      <!-- <div style="max-width: 1200px; margin: 0 auto"> -->
        <video
          src="../assets/puls.mp4"
          width="100%"
          autoplay="autoplay"
          loop="loop"
          muted
          playsinline="true"
        >
          您的浏览器不支持 video 标签。
        </video>
      <!-- </div> -->
    </div>
    <div class="general">
      <div class="item-title">一站式闭环解决方案</div>
      <div class="plan general-content">
        <div class="plan-content-left">
          <div
            v-for="(item, index) in planList"
            :key="index"
            class="plan-content-left-item"
            :class="planIndex == index ? 'active' : ''"
            @click="planIndex = index"
          >
            {{ item }}
          </div>
        </div>
        <div class="plan-content-right" v-if="planIndex == 0">
          <div class="plan-content-right-title">
            <img
              src="../assets/plan-logo.png"
              alt=""
              width="30px"
              style="margin-right: 5px"
            />
            <div>智慧文旅</div>
          </div>
          <div class="plan-content-right-Etitle">Culture and Tourism</div>
          <p>
            智能化预约系统，引导游客错峰旅游，精准管控游客流量。“全渠道、全场景、全业态”预定制，实现旅游各类服务一站式预约，满足游客多样化需求，提升旅游业现代化综合治理水平。
          </p>
          <div class="plan-content-right-nav">
            <div>景点分析</div>
            <div>客流分析</div>
            <div>节假日分析</div>
            <div>游客分析</div>
            <div>接待分析</div>
            <div>实时动态</div>
          </div>
          <div class="plan-content-right-nav">
            <img src="../assets/userLogo1.jpg" alt="" />
            <img src="../assets/userLogo2.jpg" alt="" />
          </div>
          <div class="details" @click="$router.push('/wenBrigade')">
            查看详情
          </div>
        </div>
        <div class="plan-content-right" v-if="planIndex == 1">
          <div class="plan-content-right-title">
            <img
              src="../assets/plan-logo.png"
              alt=""
              width="30px"
              style="margin-right: 5px"
            />
            <div>智慧农业</div>
          </div>
          <div class="plan-content-right-Etitle">Agriculture</div>
          <p>
            平台累计成交项目3万余宗，成交额近100亿元，为农村发展、农业增产、农民增收提供了有效服务，架起了乡村振兴的又一座桥梁。
          </p>
          <div class="plan-content-right-nav">
            <div>互联查询</div>
            <div>精准覆盖</div>
            <div>农业一张图</div>
            <div>以图管地</div>
          </div>
          <div class="plan-content-right-nav">
            <img src="../assets/userLogo3.jpg" alt="" />
            <img src="../assets/userLogo5.jpg" alt="" />
          </div>
          <div class="details" @click="$router.push('/agricultural')">
            查看详情
          </div>
        </div>
        <div class="plan-content-right" v-if="planIndex == 2">
          <div class="plan-content-right-title">
            <img
              src="../assets/plan-logo.png"
              alt=""
              width="30px"
              style="margin-right: 5px"
            />
            <div>智慧政务</div>
          </div>
          <div class="plan-content-right-Etitle">Government affairs</div>
          <p>
            成长树智能管理系统是一套居于大数据深度分析的可视化用户画像管理方案。目前已在上海公安系统率先部署使用，成为推动“智慧政工”建设的载体，为50000余名民警提供警员大数据可视化分析管理。
          </p>
          <div class="plan-content-right-nav">
            <div>智慧政工</div>
            <div>精准覆盖</div>
            <div>智能研判</div>
            <div>决策依据</div>
          </div>
          <div class="plan-content-right-nav">
            <img src="../assets/userLogo4.jpg" alt="" />
          </div>
          <div class="details" @click="$router.push('/security')">查看详情</div>
        </div>
      </div>
    </div>
    <div class="general case">
      <div class="item-title">头部客户成功案例</div>
      <div class="case-nav">
        <div
          v-for="(item, index) in caseList"
          :key="index"
          class="case-nav-item"
          :class="caseIndex == index ? 'active' : ''"
          @click="caseIndex = index"
        >
          {{ item }}
        </div>
      </div>
      <div class="case-content general-content">
        <div
          class="case-content-item"
          v-for="(item, index) in caseData[caseIndex]"
          :key="index"
        >
          <img :src="item.img1" alt="" />
          <div class="case-content-item-bottom">
            <img :src="item.img2" alt="" />
            <div>
              <h4>{{ item.name }}</h4>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="general user">
      <div class="user-title">我们的客户</div>
      <div class="user-content general-content">
        <div class="user-content-row">
          <img
            v-for="(colitem, colindex) in 24"
            :key="colindex"
            :src="require('../assets/userLogo' + colitem + '.jpg')"
          />
        </div>
      </div>
    </div>
    <!-- <div class="general bottom">
      <img src="../assets/footer.png" alt="" class="general-content" />
    </div> -->
    <!-- <myfooter :type="0"></myfooter> -->
  </div>
</template>
<script>
// import myfooter from "../components/myfooter.vue";
import mynav from "../components/mynav.vue";
export default {
  data() {
    return {
      planList: ["智慧文旅", "智慧农业", "智慧政务"],
      planIndex: 0,
      caseList: ["文旅", "农业", "政务"],
      caseData: [
        [
          {
            name: "徐汇文旅平台",
            text: "一键实名预约支持购票及支付精控导流",
            img1: require("../assets/cover1.png"),
            img2: require("../assets/coverLogo1.jpg"),
          },
          {
            name: "青浦文旅平台",
            text: "一键实名预约支持购票及支付精控导流",
            img1: require("../assets/cover2.png"),
            img2: require("../assets/coverLogo2.jpg"),
          },
        ],
        [
          {
            name: "上海农业要素交易所",
            text: "上海市公共资源交易平台全国第一",
            img1: require("../assets/cover3.jpg"),
            img2: require("../assets/coverLogo3.jpg"),
          },
        ],
        [
          {
            name: "上海市公安局",
            text: "警员绩效，大数据应用系统",
            img1: require("../assets/cover4.jpg"),
            img2: require("../assets/coverLogo4.jpg"),
          },
          {
            name: "司法鉴定科学研究院",
            text: "为科研、教培、技术执法赋能",
            img1: require("../assets/cover5.jpg"),
            img2: require("../assets/coverLogo5.jpg"),
          },
          {
            name: "数字哨兵",
            text: "上海大数据中心合作伙伴",
            img1: require("../assets/cover6.jpg"),
            img2: require("../assets/coverLogo6.jpg"),
          },
        ],
      ],
      caseIndex: 0,
    };
  },
  components: {
    // myfooter,
    mynav,
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelector("video").play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          document.querySelector("video").play();
        },
        false
      );
    });
  },
  methods: {
    getUserLogo(rowIndex, colindex) {
      let index = rowIndex * 8 + colindex;
      return require("../assets/userLogo" + index + ".png");
    },
  },
};
</script>
<style lang="less" scoped>
.el-carousel {
  margin-bottom: 40px;
}
.el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan {
  display: flex;
  .plan-content-left {
    width: 15%;
    padding: 25px 30px 20px 10px;
    box-sizing: border-box;
    background-color: #21293e;
    .plan-content-left-item {
      color: #fff;
      text-align: center;
      width: 100%;
      margin-bottom: 40px;
      cursor: pointer;
      border-left: 3px solid transparent;
    }
    .active {
      color: #2659e6;
      border-left: 3px solid #2659e6;
    }
  }
  .plan-content-right {
    width: 85%;
    padding: 20px 70px 50px 70px;
    box-sizing: border-box;
    background-color: #f3f7fa;
    .plan-content-right-title {
      display: flex;
      color: #242b43;
      font-size: 24px;
    }
    .plan-content-right-Etitle {
      color: #242b4387;
      font-size: 14px;
      margin-top: 5px;
    }
    p {
      color: #2a2d36;
      line-height: 20px;
      margin-top: 20px;
      font-size: 14px;
    }
    .plan-content-right-nav {
      display: flex;
      margin-top: 24px;
      flex-wrap: wrap;
      div {
        padding: 5px 14px;
        border: 1px solid #9296a3;
        color: #9296a3;
        font-size: 12px;
        margin-right: 10px;
        margin-bottom: 6px;
      }
      img {
        width: 70px;
        height: 70px;
        margin-right: 20px;
        border-radius: 50%;
      }
    }
    .details {
      width: 87.5px;
      line-height: 24.5px;
      text-align: center;
      color: #fff;
      background-color: rgb(38, 89, 230);
      font-size: 12px;
      margin-top: 30px;
      cursor: pointer;
    }
  }
}
.case {
  .case-nav {
    display: flex;
    justify-content: center;
    .case-nav-item {
      color: #242b43;
      font-size: 14px;
      padding: 10px 15px;
      border-bottom: 3px solid transparent;
      margin: 0 20px;
      font-weight: 600;
      cursor: pointer;
    }
    .active {
      color: #2659e6;
      border-bottom: 3px solid #2659e6;
    }
  }
  .case-content {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .case-content-item {
      width: 300px;
      margin: 10px 8.6px;
      box-shadow: 0px 4px 14px rgba(75, 103, 136, 0.1);
      img {
        width: 100%;
      }
      .case-content-item-bottom {
        display: flex;
        align-items: center;
        color: #21293e;
        padding: 10px 5px;
        box-sizing: border-box;
        img {
          width: 65px;
        }
        p {
          font-size: 10px;
        }
      }
    }
  }
}
.user {
  background-color: #21293e;
  padding: 70px 0;
  .user-title {
    font-size: 30px;
    color: #fff;
    font-weight: 600;
    text-align: center;
  }
  .user-content {
    margin-top: 40px;
    .user-content-row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-top: 20px;
      img {
        width: 12.5%;
        padding: 5px;
        box-sizing: border-box;
      }
    }
  }
}
.bottom {
  width: 100%;
  img {
    display: block;
  }
}

@media screen and (max-width: 992px) {
}

@media screen and (max-width: 768px) {
  .el-carousel {
    margin-bottom: 20px;
  }
  .plan {
    display: block;
    .plan-content-left {
      width: 100%;
      padding: 0;
      background-color: #fff;
      display: flex;
      .plan-content-left-item {
        color: #21293e;
        width: 20%;
        margin-bottom: 20px;
        padding: 15px 0;
        font-size: 2.5vw;
      }
      .active {
        background-color: #2659e6;
        color: #fff;
      }
    }
    .plan-content-right {
      width: 100%;
      padding: 30px 20px;
      box-sizing: border-box;
    }
  }
  .case {
    .case-nav {
      .case-nav-item {
        padding: 5px 10px;
        margin: 0 10px;
      }
    }
    .case-content {
      justify-content: space-between;
      .case-content-item {
        width: 48%;
        margin: 0 0 10px 0;
        .case-content-item-bottom {
          padding: 8px 3px;
          img {
            width: 40px;
          }
          h4 {
            font-size: 14px;
          }
          p {
            font-size: 10px;
          }
        }
      }
    }
  }

  .bottom {
    display: none;
  }
  .user {
    padding: 30px 0;
    .user-title {
      font-size: 24px;
    }
    .user-content {
      margin-top: 20px;
    }
  }
}
</style>